import Vue from "vue";

import { config } from "../api/user.config.api";
import { UserConfig, User } from "../types/users";

interface ConfigState {
	config: UserConfig;
	fetched: boolean;
}

const state: ConfigState = {
	config: {
		meetingsenabled: false,
		searchresultssort: null,
		searchresultsview: null,
		terms: false,
		userid: 0
	},
	fetched: false
};

const getters = {
	terms: state => state.config.terms as Boolean,
	config: state => state.config as UserConfig,
	fetched: state => state.fetched as Boolean
};

const actions = {
	async fetch({ commit }, user: User) {
		if (user) {
			const { id } = user;
			const _config = await config.get(id);
			commit(`UPDATE_TERMS`, _config);
		}
	},
	async agree({ commit, state }) {
		const confirm = { ...state.config, terms: true };
		const _config = await config.update(confirm);
		commit(`UPDATE_TERMS`, _config);
	}
};

const mutations = {
	UPDATE_TERMS({ state: UserConfig }, config: UserConfig) {
		state.config = config;
		state.fetched = true;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
